/**
 * Featured listings carousel — [lovasok_featured_listings]
 *
 * @package Lovasok_Marketplace
 */

let favoriteDelegationBound = false;
let observerStarted = false;

function getLoginUrl() {
    const home = (window.lovasokParams?.homeUrl || '').replace(/\/$/, '');
    return `${home}/bejelentkezes`;
}

async function toggleFeaturedFavorite(btn) {
    if (btn.dataset.lmkFavBusy === '1') return;

    const horseId = btn.getAttribute('data-lmk-fav');
    if (!horseId) return;

    btn.dataset.lmkFavBusy = '1';
    btn.setAttribute('aria-busy', 'true');

    const setActive = (active) => {
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute(
            'aria-label',
            active ? 'Eltávolítás a kedvencekből' : 'Kedvencekhez adás'
        );
    };

    try {
        let data;
        if (window.LovasokAPI?.post) {
            data = await window.LovasokAPI.post(`horses/${horseId}/favorite`);
        } else {
            const params = window.lovasokParams || {};
            const res = await fetch(
                `${params.apiUrl || '/wp-json/lovasok/v1/'}horses/${horseId}/favorite`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': params.nonce || '',
                    },
                    credentials: 'same-origin',
                }
            );
            if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                throw new Error(body.message || String(res.status));
            }
            data = await res.json();
        }
        setActive(!!data.favorited);
    } catch (err) {
        const msg = err?.message || '';
        if (msg.includes('401') || msg.includes('403') || msg.includes('jogosultság')) {
            window.location.href = getLoginUrl();
            return;
        }
        if (msg.includes('Saját hirdetés')) {
            alert('Saját hirdetésedet nem adhatod kedvencekhez.');
            return;
        }
        console.error('Featured favorite toggle failed:', err);
    } finally {
        delete btn.dataset.lmkFavBusy;
        btn.removeAttribute('aria-busy');
    }
}

function ensureFavoriteDelegation() {
    if (favoriteDelegationBound) return;
    favoriteDelegationBound = true;

    // Capture phase — beat card link navigation on mobile taps.
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-lmk-fav]');
        if (!btn || !btn.closest('[data-lmk-feat-root]')) return;

        e.preventDefault();
        e.stopPropagation();
        toggleFeaturedFavorite(btn);
    }, true);

    document.addEventListener('pointerdown', (e) => {
        const btn = e.target.closest('[data-lmk-fav]');
        if (!btn || !btn.closest('[data-lmk-feat-root]')) return;
        e.stopPropagation();
    }, true);
}

function initCarouselRoot(root) {
    if (!root || root.dataset.lmkFeatInit) return;
    root.dataset.lmkFeatInit = '1';

    const track = root.querySelector('[data-lmk-feat-track]');
    if (!track) return;

    const prev = root.querySelector('[data-lmk-feat-prev]');
    const next = root.querySelector('[data-lmk-feat-next]');
    const nav = root.querySelector('[data-lmk-feat-nav]');
    const cards = track.querySelectorAll('.lmk-featured-card');

    if (nav && cards.length <= 1) {
        nav.hidden = true;
    } else if (nav) {
        nav.removeAttribute('aria-hidden');
    }

    const step = () => {
        const card = track.querySelector('.lmk-featured-card');
        const base = card ? card.getBoundingClientRect().width : 280;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
        return base + gap;
    };

    const update = () => {
        if (!prev || !next) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
        next.classList.toggle('is-disabled', track.scrollLeft >= max);
    };

    if (prev) {
        prev.addEventListener('click', () => {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
    }
    if (next) {
        next.addEventListener('click', () => {
            track.scrollBy({ left: step(), behavior: 'smooth' });
        });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
}

export function initFeaturedCarousels() {
    ensureFavoriteDelegation();
    document.querySelectorAll('[data-lmk-feat-root]').forEach(initCarouselRoot);
}

function ensureLateInitObserver() {
    if (observerStarted || typeof MutationObserver === 'undefined') return;
    observerStarted = true;

    let timer = null;
    const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = window.setTimeout(() => initFeaturedCarousels(), 120);
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFeaturedCarousels);
    }
    window.addEventListener('load', initFeaturedCarousels);
    ensureLateInitObserver();
}
